<template>
  <div class="box box-secondary">
    <div class="box-header with-border">
      <i class="fa fa-shopping-cart"></i>
      <h3 class="box-title">{{'latest_orders' | translate | capitalize}} <small>[{{orders.length}}]</small></h3>
      <div class="box-tools pull-right">
        <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
        <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
      </div>
    </div>
    <div class="box-body">
      <div class="table-responsive">
        <table class="table no-margin table-hover table-striped">
          <thead>
          <tr>
            <th>{{'order' | translate}} ID</th>
            <th>{{'date' | translate}}</th>
            <th>{{'title' | translate}}</th>
            <th style="width:1%">{{'status' | translate}}</th>
            <th>{{'sales_channel' | translate | capitalize}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="order in orders">
            <td>{{ order.ext_order_id }}</td>
            <td>{{ order.order_date  | orderDate }}<span class="fa fa-clock-o pl-5 ml-5 mr-5"></span> {{ order.order_date  | orderDate(true) }}</td>
            <td><router-link :to="'/orders/'+order.order_id">{{ order.title  | orderTitle }}</router-link></td>
            <td>
              <span style="display: block" :class="order.status[1]">{{order.status[0] | translate | toUpper}}</span>
            </td>
            <td v-if="order.order_type === 'AmazonPrime'">
              <img class="img-responsive img-channel" :src="'static/img/amazon-prime.svg'">
            </td>
            <td v-else>
              <img class="img-responsive img-channel" :src="'static/img/' + order.sales_channel + '.svg'">
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="box-footer clearfix text-left">
      <a class="btn btn-success"><router-link to="/orders">{{'view_all_orders' | translate}}</router-link></a>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      orders: {}
    }
  },
  methods: {
    format (name) {
      return name === 'schuhede' ? name : name.toLowerCase().substring(0, name.length - 3)
    },
    getStatus (status) {
      if (status.is_exported === null) {
        return ['error', 'label label-secondary']
      }
      if (status.is_canceled === 1) {
        return ['canceled', 'label label-danger']
      }
      if (status.is_return === 1) {
        return ['returned_status', 'label label-danger']
      }
      if (status.is_shipped === 1) {
        return ['shipped_status', 'label label-success']
      }
      if (status.is_exported === 0) {
        return ['processing', 'label label-primary']
      }
      if (status.is_exported === 1) {
        return ['pending', 'label label-warning']
      }
      return ['error', 'label label-secondary']
    }
  },
  mounted () {
    this.$nextTick(() => {
      API.get('dashboard/order-data')
        .then( response => {
          this.orders = response.data
          for (let x in this.orders) {
            this.orders[x].status = this.getStatus(this.orders[x])
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/OrderComponent.vue